import useSWR from "swr";
import fetcher from "../lib/fetcher";

import Navbar from "../components/navigation/Navbar";
import Footer from "../components/Layout/Footer";
import Spinner from "../components/Spinner";
import Error from "../components/Error";

import salesmen from "../data/salesman";

export default function Kontakt() {
  const { data, error } = useSWR("/api/infos/kontakt", fetcher);
  const kontakt = data;

  if (error) return <Error error={error} />;
  if (!data) return <Spinner />;

  const locations = [
    {
      city: "EINKAUFSBÜRO MAINBURG",
      name: kontakt.companyName,
      address: kontakt.address1 + ", " + kontakt.zipCode + " " + kontakt.city,
      phone: kontakt.phone,
      fax: kontakt.fax,
      mail: kontakt.mail,
    },
    {
      city: "EINKAUFSBÜRO TETTNANG",
      name: kontakt.companyName,
      name2: kontakt.secondOffice1,
      address: kontakt.secondOffice2 + ", " + kontakt.secondOffice3,
      phone: kontakt.secondOffice4,
      fax: kontakt.secondOffice5,
      mail: kontakt.secondOffice6,
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main>
        <div className="lg:relative bg-primary">
          <div className="lg:flex">
            <div className="lg:w-3/5 bg-image bg-cover min-h-[400px] bg-[position:50%_15%]"
              style={{
                backgroundImage: "url('/salesman/Hopsteiner-Team-Einkauf.webp')",
              }}
              aria-label="Hopsteiner Einkaufs Team"
            ></div>

            <div className="lg:w-2/5 p-8">
              <div className="grid sm:grid-cols-2 lg:grid-cols-1 gap-8">
                {locations.map((location) => (
                  <div key={location.city} className="flex xh-full flex-col text-white">
                    <div>
                      <h3 className="font-bold uppercase text-lg mb-2">{location.city}</h3>
                      <p className="font-bold">{location.name}</p>
                      <p className="text-italic">{location.name2}</p>
                      <p>{location.address}</p>
                    </div>

                    <div className="mt-auto pt-4 font-light">
                      <p>
                        <b>Telefon:</b> {location.phone}
                      </p>
                      <p>
                        <b>Fax:</b> {location.fax}
                      </p>
                      <p>
                        <b>E-Mail:</b>{" "}
                        <a className="hover:text-secondary" href={`mailto:${kontakt.email}`}>
                          {kontakt.email}
                        </a>
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Side-by-side grid */}
        <div className="bg-white">
          <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
            <div className="space-y-12">
              <div className="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none">
                <h2 className="font-display uppercase text-primary text-3xl font-extrabold tracking-tight sm:text-4xl">Einkaufsteam</h2>
              </div>
              <ul className="space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8">
                {salesmen.map((person) => (
                  <li key={person.name}>
                    <div className={person.name ? "space-y-4" : "space-y-4 mt-32"}>
                      <img className="aspect-square w- flex-none shadow-lg rounded-2xl object-cover" src={person.imageUrl} alt={person.name} />
                      <div className="space-y-2">
                        <div className="text-lg leading-6 font-medium space-y-1">
                          <h3>{person.name}</h3>
                          <p className="text-primary">{person.role}</p>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
